// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Link-module--bx--text-truncate--end--31ehW","bxTextTruncateFront":"Link-module--bx--text-truncate--front--26aVr","link":"Link-module--link--n4L7L"};